import React from 'react';
import { FormSection } from 'redux-form';
import { takeFormErrors } from 'src/utils/Form';
import HeadErrors from 'src/components/HeadErrors';
import RevisionItemBody from './RevisionItemBody';
import RevisionItemHeader from './RevisionItemHeader';

const fieldMap = {
  firstMonthBasicDays: '1ヶ月目の支払基礎日数',
  secondMonthBasicDays: '2ヶ月目の支払基礎日数',
  thirdMonthBasicDays: '3ヶ月目の支払基礎日数',
  firstMonthCurrencyAmount: '1ヶ月目の通貨による額',
  secondMonthCurrencyAmount: '2ヶ月目の通貨による額',
  thirdMonthCurrencyAmount: '3ヶ月目の通貨による額',
  firstMonthGenbutsuAmount: '1ヶ月目の現物による額',
  secondMonthGenbutsuAmount: '2ヶ月目の現物による額',
  thirdMonthGenbutsuAmount: '3ヶ月目の現物による額',
  firstMonthRetroactiveAmount: '1ヶ月目の遡及支払額',
  secondMonthRetroactiveAmount: '2ヶ月目の遡及支払額',
  thirdMonthRetroactiveAmount: '3ヶ月目の遡及支払額',
  modifiedAverageAmount: '修正平均額',
  totalRetroactiveAmount: '遡及支払額',
  changedAmount: '昇給差の月額',
  note: '備考'
};

const RevisionItem = ({
  revision,
  formRevision,
  errors,
  showMode,
  changedYearMonths,
  lastRevisionYearMonths,
  changeToEditMode,
  changeToManualCalcMode,
  notifyValueChanges,
  cancel,
  save,
  recalculate,
  reset,
  setFormField
}) => (
  <div className="u-mb40">
    <FormSection name={`revisions.${revision.id}`}>
      <RevisionItemHeader
        revision={revision}
        formRevision={formRevision}
        showMode={showMode}
        changeToEditMode={changeToEditMode}
        cancel={cancel}
        save={save}
        reset={reset}
      />
      <HeadErrors errors={takeFormErrors(errors, fieldMap)} />
      <RevisionItemBody
        revision={revision}
        formRevision={formRevision}
        showMode={showMode}
        changedYearMonths={changedYearMonths}
        recalculate={recalculate}
        changeToManualCalcMode={changeToManualCalcMode}
        notifyValueChanges={notifyValueChanges}
        setFormField={setFormField}
        lastRevisionYearMonths={lastRevisionYearMonths}
      />
    </FormSection>
  </div>
);

export default RevisionItem;
